module.exports = __webpack_public_path__ + "static/img/fany-color.101f37b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fany-color.png
// module id = 207
// module chunks = 0